<template>
    <v-dialog
        :value="isOpen"
        scrollable
        max-width="500px"
        transition="slide-y-transition"
        eager
        @keydown.esc="onClose"
        @click:outside="onClose"
    >
        <v-card>
            <v-card-title>
                <h1 class="text-subtitle-1">
                    <template>
                        Edycja rodzaju wysyłki
                    </template>
                </h1>
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="12">
                        <v-autocomplete
                            v-model="task.deliveryMethodId"
                            :items="availableDeliveryMethods"
                            item-value="id"
                            item-text="name"
                            label="Transport"
                            outlined
                            dense
                            clearable
                            hide-details
                            @change="handleDeliveryMethodChange"
                        />
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="6">
                        <v-text-field
                            :value="distance"
                            label="Dystans"
                            suffix="km"
                            outlined
                            dense
                            hide-details
                            @input="handleDistance"
                        />
                    </v-col>
                    <v-col cols="6">
                        <v-btn
                            color="success"
                            data-sentry-label="Oblicz"
                            :disabled="isCalculateDeliveryCostDisabled"
                            @click="calculateDeliveryCost"
                        >
                            Oblicz koszt wysyłki
                        </v-btn>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="12">
                        <v-text-field
                            :value="transportCost"
                            label="Koszt"
                            suffix="zł"
                            outlined
                            dense
                            :hide-details="!transportCostError"
                            :error="!!transportCostError"
                            :hint="transportCostError"
                            @input="handleCost"
                            @change="transportCostChange"
                        />
                    </v-col>
                </v-row>
            </v-card-text>

            <v-divider />

            <v-card-actions>
                <v-btn
                    color="error"
                    text
                    data-sentry-label="Anuluj"
                    @click="onClose"
                >
                    Anuluj
                </v-btn>
                <v-spacer />
                <v-btn
                    color="success"
                    text
                    data-sentry-label="Dodaj"
                    :disabled="isSaveDisabled"
                    @click="onSave"
                >
                    Zapisz
                </v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>

import { mask } from 'vue-the-mask'
import parse from '@/mixins/parse'
import { errorHandler } from '@/utils/errorHandler'

export default {
    name: 'SendingParametersDialog',
    directives: { mask },
    mixins: [ parse ],
    props: {
        isOpen: {
            type: Boolean
        },
        taskData: {
            type: Object,
            default: null
        },
        impositionPackages: {
            type: Array,
            default: () => []
        },
        totalDeliveryWeight: {
            type: Number,
            default: 0
        },
        deliveryMethods: {
            type: Array,
            default: () => []
        }
    },
    data() {
        return {
            task: {},
            factor: null,
            kilometers: null,
        }
    },
    computed: {
        transportTaskProperty() {
            return this.task.impositionTaskProperties?.find(item => item.productionProcessPropertyId === 10)
        },
        transportTaskPropertyItems() {
            if (this.transportTaskProperty) {
                return this.transportTaskProperty.productionProcessProperty.productionProcessPropertyValues
            }

            return []
        },
        transportTaskPropertyValue() {
            return this.transportTaskProperty ? this.transportTaskProperty.value : null
        },
        transportDistanceTaskProperty() {
            return this.task.impositionTaskProperties?.find(item => item.productionProcessPropertyId === 26)
        },
        transportCostTaskProperty() {
            return this.task.impositionTaskProperties?.find(item => item.productionProcessPropertyId === 20)
        },
        distance() {
            return this.transportDistanceTaskProperty ? this.transportDistanceTaskProperty.value : ''
        },
        transportCost() {
            return this.transportCostTaskProperty ? this.transportCostTaskProperty.value : ''
        },
        isCalculateDeliveryCostDisabled() {
            return !this.task.deliveryMethodId || this.transportDistanceTaskProperty?.value === '' || this.transportDistanceTaskProperty?.value === null
        },
        transportCostError() {
            const regex = /^\d*(\.\d{0,2})?$/
            const value = this.transportCost

            if (value === null || value === '' || value === undefined) {
                return ''
            }
            if (!regex.test(value.toString())) {
                return 'Maksymalnie 2 cyfry po przecinku'
            }

            return ''
        },
        isSaveDisabled() {
            return !!this.transportCostError || !this.task.deliveryMethodId
        },
        isCustomerTransport() {
            return this.taskData.deliveryMethodId === 20
        },
        isCourierTransport() {
            return this.taskData.deliveryMethodId === 22
        },
        availableDeliveryMethods() {
            const available = this.deliveryMethods.filter(item => item.isAvailableInTransportSelection)
            const currentId = this.taskData && this.taskData.deliveryMethodId
            let list = available

            if (currentId && !available.some(item => item.id === currentId)) {
                const current = this.deliveryMethods.find(item => item.id === currentId)

                if (current) {
                    list = [...available, current]
                }
            }

            return list
        }
    },
    watch: {
        isOpen(boolean) {
            if (boolean) {
                this.task = JSON.parse(JSON.stringify(this.taskData))
            } else {
                setTimeout(() => {
                    this.task = {}
                }, 500)
            }
        }
    },
    methods: {
        setDistanceValue() {
            this.task.impositionTaskProperties.find(item => item.productionProcessPropertyId === 26).value = '-'
        },
        handleDeliveryMethodChange() {
            this.clearTransportDistanceTaskProperty()
            this.clearTransportCostTaskProperty()
        },
        clearTransportDistanceTaskProperty() {
            this.transportDistanceTaskProperty.value =
                this.isCustomerTransport || this.isCourierTransport
                    ? 0
                    : ''
        },
        clearTransportCostTaskProperty() {
            this.task.impositionTaskProperties
                .find(item => item.productionProcessPropertyId === 20).value =
                    this.isCustomerTransport || this.isCourierTransport
                        ? 0
                        : ''
        },
        setTransportCostTaskPropertyValue() {
            const cost = this.calculateCost(this.kilometers, this.factor)

            this.handleCost(cost)
        },
        calculateCost(distance, factor) {
            return Math.ceil(parseInt(distance) * factor).toString()

        },
        handleDistance(value) {
            value = value ? value : ''
            this.task.impositionTaskProperties.find(item => item.productionProcessPropertyId === 26).value = value
            this.kilometers = value
        },
        handleCost(value) {
            this.task.impositionTaskProperties.find(item => item.productionProcessPropertyId === 20).value = value
        },
        transportCostChange() {
            this.handleCost(parseFloat(this.transportCost) || 0)
        },
        onSave() {
            this.$emit('on-save', this.task)
        },
        onClose() {
            this.$emit('on-close')
        },
        async calculateDeliveryCost() {
            const payload = {
                deliveryMethodId: this.task.deliveryMethodId,
                distance: parseInt(this.distance),
                weight: this.totalDeliveryWeight,
                packagesQuantities: this.impositionPackages.map(item => ({
                    packageTypeId: item.packageType,
                    quantity: item.packageAmount,
                })),
            }

            return await this.$store.dispatch('calculations/calculateDeliveryCost', payload)
                .then(response => {
                    this.handleCost(response.data.price)
                })
                .catch(error => {
                    errorHandler(error)
                })
        },
    }
}
</script>